import React from 'react'
import { Routes } from '../../../setup/consts'
import generatePath from '../../../utils/generatePath'
import usePageContext from '../../../hooks/usePageContext'
import DailyMarketNewsSection from '../../sections/DailyMarketNewsSection'
import { MarketNewsSliceProps } from './types'

const MarketNewsSlice: React.FC<MarketNewsSliceProps> = ({ slice }) => {
  const { lang, group } = usePageContext()
  const { mn_title, mn_is_main_heading, mn_all_news_text } = slice.primary || {}

  return (
    <DailyMarketNewsSection
      id={slice.id}
      heading={mn_title?.text}
      isMainHeading={mn_is_main_heading}
      inner="inners.overflowSlider"
      paddingTop={['80px', '', '120px']}
      paddingBottom={['20px', '', '120px']}
      headingPadding={['38px', '', '70px']}
      data={{
        client: {
          lang,
          clientId: process.env.GATSBY_XCLIENT_CLIENT_ID,
          product: process.env.GATSBY_XCLIENT_PRODUCT,
          assetmode: process.env.GATSBY_XCLIENT_ASSETMODE,
          asset: process.env.GATSBY_XCLIENT_ASSET
        },
        cta: mn_all_news_text
          ? {
              url: generatePath(Routes.MarketNews, { lang, group }),
              urlText: mn_all_news_text,
              urlIsExternal: false,
              urlIsLogin: false,
              urlIsRegister: false
            }
          : undefined
      }}
    />
  )
}

export default MarketNewsSlice
